"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
/**
 * A lightweight youtube embed. Still should feel the same to the user, just MUCH faster to initialize and paint.
 *
 * Thx to these as the inspiration
 *   https://storage.googleapis.com/amp-vs-non-amp/youtube-lazy.html
 *   https://autoplay-youtube-player.glitch.me/
 *
 * Once built it, I also found these:
 *   https://github.com/ampproject/amphtml/blob/master/extensions/amp-youtube (👍👍)
 *   https://github.com/Daugilas/lazyYT
 *   https://github.com/vb/lazyframe
 */
var LiteYTEmbed = /*#__PURE__*/function (_HTMLElement) {
  function LiteYTEmbed() {
    _classCallCheck(this, LiteYTEmbed);
    return _callSuper(this, LiteYTEmbed, arguments);
  }
  _inherits(LiteYTEmbed, _HTMLElement);
  return _createClass(LiteYTEmbed, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;
      this.videoId = this.getAttribute('videoid');
      var playBtnEl = this.querySelector('.lty-playbtn');
      // A label for the button takes priority over a [playlabel] attribute on the custom-element
      this.playLabel = playBtnEl && playBtnEl.textContent.trim() || this.getAttribute('playlabel') || 'Play';
      this.dataset.title = this.getAttribute('title') || "";

      /**
       * Lo, the youtube poster image!  (aka the thumbnail, image placeholder, etc)
       *
       * See https://github.com/paulirish/lite-youtube-embed/blob/master/youtube-thumbnail-urls.md
       */
      if (!this.style.backgroundImage) {
        this.style.backgroundImage = "url(\"https://i.ytimg.com/vi/".concat(this.videoId, "/hqdefault.jpg\")");
        this.upgradePosterImage();
      }

      // Set up play button, and its visually hidden label
      if (!playBtnEl) {
        playBtnEl = document.createElement('button');
        playBtnEl.type = 'button';
        playBtnEl.classList.add('lty-playbtn');
        this.append(playBtnEl);
      }
      if (!playBtnEl.textContent) {
        var playBtnLabelEl = document.createElement('span');
        playBtnLabelEl.className = 'lyt-visually-hidden';
        playBtnLabelEl.textContent = this.playLabel;
        playBtnEl.append(playBtnLabelEl);
      }
      this.addNoscriptIframe();

      // for the PE pattern, change anchor's semantics to button
      if (playBtnEl.nodeName === 'A') {
        playBtnEl.removeAttribute('href');
        playBtnEl.setAttribute('tabindex', '0');
        playBtnEl.setAttribute('role', 'button');
        // fake button needs keyboard help
        playBtnEl.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            _this.activate();
          }
        });
      }

      // On hover (or tap), warm up the TCP connections we're (likely) about to use.
      this.addEventListener('pointerover', LiteYTEmbed.warmConnections, {
        once: true
      });
      this.addEventListener('focusin', LiteYTEmbed.warmConnections, {
        once: true
      });

      // Once the user clicks, add the real iframe and drop our play button
      // TODO: In the future we could be like amp-youtube and silently swap in the iframe during idle time
      //   We'd want to only do this for in-viewport or near-viewport ones: https://github.com/ampproject/amphtml/pull/5003
      this.addEventListener('click', this.activate);

      // Chrome & Edge desktop have no problem with the basic YouTube Embed with ?autoplay=1
      // However Safari desktop and most/all mobile browsers do not successfully track the user gesture of clicking through the creation/loading of the iframe,
      // so they don't autoplay automatically. Instead we must load an additional 2 sequential JS files (1KB + 165KB) (un-br) for the YT Player API
      // TODO: Try loading the the YT API in parallel with our iframe and then attaching/playing it. #82
      this.needsYTApi = this.hasAttribute("js-api") || navigator.vendor.includes('Apple') || navigator.userAgent.includes('Mobi');
    }

    /**
     * Add a <link rel={preload | preconnect} ...> to the head
     */
  }, {
    key: "fetchYTPlayerApi",
    value: function fetchYTPlayerApi() {
      var _this2 = this;
      if (window.YT || window.YT && window.YT.Player) return;
      this.ytApiPromise = new Promise(function (res, rej) {
        var el = document.createElement('script');
        el.src = 'https://www.youtube.com/iframe_api';
        el.async = true;
        el.onload = function (_) {
          YT.ready(res);
        };
        el.onerror = rej;
        _this2.append(el);
      });
    }

    /** Return the YT Player API instance. (Public L-YT-E API) */
  }, {
    key: "getYTPlayer",
    value: async function getYTPlayer() {
      if (!this.playerPromise) {
        await this.activate();
      }
      return this.playerPromise;
    }
  }, {
    key: "addYTPlayerIframe",
    value: async function addYTPlayerIframe() {
      var _this3 = this;
      this.fetchYTPlayerApi();
      await this.ytApiPromise;
      var videoPlaceholderEl = document.createElement('div');
      this.append(videoPlaceholderEl);
      var paramsObj = Object.fromEntries(this.getParams().entries());
      this.playerPromise = new Promise(function (resolve) {
        var player = new YT.Player(videoPlaceholderEl, {
          width: '100%',
          videoId: _this3.videoId,
          playerVars: paramsObj,
          events: {
            'onReady': function onReady(event) {
              event.target.playVideo();
              resolve(player);
            }
          }
        });
      });
    }

    // Add the iframe within <noscript> for indexability discoverability. See https://github.com/paulirish/lite-youtube-embed/issues/105
  }, {
    key: "addNoscriptIframe",
    value: function addNoscriptIframe() {
      var iframeEl = this.createBasicIframe();
      var noscriptEl = document.createElement('noscript');
      // Appending into noscript isn't equivalant for mysterious reasons: https://html.spec.whatwg.org/multipage/scripting.html#the-noscript-element
      noscriptEl.innerHTML = iframeEl.outerHTML;
      this.append(noscriptEl);
    }
  }, {
    key: "getParams",
    value: function getParams() {
      var params = new URLSearchParams(this.getAttribute('params') || []);
      params.append('autoplay', '1');
      params.append('playsinline', '1');
      return params;
    }
  }, {
    key: "activate",
    value: async function activate() {
      if (this.classList.contains('lyt-activated')) return;
      this.classList.add('lyt-activated');
      if (this.needsYTApi) {
        return this.addYTPlayerIframe(this.getParams());
      }
      var iframeEl = this.createBasicIframe();
      this.append(iframeEl);

      // Set focus for a11y
      iframeEl.focus();
    }
  }, {
    key: "createBasicIframe",
    value: function createBasicIframe() {
      var iframeEl = document.createElement('iframe');
      iframeEl.width = 560;
      iframeEl.height = 315;
      // No encoding necessary as [title] is safe. https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html#:~:text=Safe%20HTML%20Attributes%20include
      iframeEl.title = this.playLabel;
      iframeEl.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframeEl.allowFullscreen = true;
      // AFAIK, the encoding here isn't necessary for XSS, but we'll do it only because this is a URL
      // https://stackoverflow.com/q/64959723/89484
      iframeEl.src = "https://www.youtube-nocookie.com/embed/".concat(encodeURIComponent(this.videoId), "?").concat(this.getParams().toString());
      return iframeEl;
    }

    /**
     * In the spirit of the `lowsrc` attribute and progressive JPEGs, we'll upgrade the reliable
     * poster image to a higher resolution one, if it's available.
     * Interestingly this sddefault webp is often smaller in filesize, but we will still attempt it second
     * because getting _an_ image in front of the user if our first priority.
     *
     * See https://github.com/paulirish/lite-youtube-embed/blob/master/youtube-thumbnail-urls.md for more details
     */
  }, {
    key: "upgradePosterImage",
    value: function upgradePosterImage() {
      var _this4 = this;
      // Defer to reduce network contention.
      setTimeout(function () {
        var webpUrl = "https://i.ytimg.com/vi_webp/".concat(_this4.videoId, "/sddefault.webp");
        var img = new Image();
        img.fetchPriority = 'low'; // low priority to reduce network contention
        img.referrerpolicy = 'origin'; // Not 100% sure it's needed, but https://github.com/ampproject/amphtml/pull/3940
        img.src = webpUrl;
        img.onload = function (e) {
          // A pretty ugly hack since onerror won't fire on YouTube image 404. This is (probably) due to
          // Youtube's style of returning data even with a 404 status. That data is a 120x90 placeholder image.
          // … per "annoying yt 404 behavior" in the .md
          var noAvailablePoster = e.target.naturalHeight == 90 && e.target.naturalWidth == 120;
          if (noAvailablePoster) return;
          _this4.style.backgroundImage = "url(\"".concat(webpUrl, "\")");
        };
      }, 100);
    }
  }], [{
    key: "addPrefetch",
    value: function addPrefetch(kind, url, as) {
      var linkEl = document.createElement('link');
      linkEl.rel = kind;
      linkEl.href = url;
      if (as) {
        linkEl.as = as;
      }
      document.head.append(linkEl);
    }

    /**
     * Begin pre-connecting to warm up the iframe load
     * Since the embed's network requests load within its iframe,
     *   preload/prefetch'ing them outside the iframe will only cause double-downloads.
     * So, the best we can do is warm up a few connections to origins that are in the critical path.
     *
     * Maybe `<link rel=preload as=document>` would work, but it's unsupported: http://crbug.com/593267
     * But TBH, I don't think it'll happen soon with Site Isolation and split caches adding serious complexity.
     */
  }, {
    key: "warmConnections",
    value: function warmConnections() {
      if (LiteYTEmbed.preconnected) return;

      // The iframe document and most of its subresources come right off youtube.com
      LiteYTEmbed.addPrefetch('preconnect', 'https://www.youtube-nocookie.com');
      // The botguard script is fetched off from google.com
      LiteYTEmbed.addPrefetch('preconnect', 'https://www.google.com');

      // Not certain if these ad related domains are in the critical path. Could verify with domain-specific throttling.
      LiteYTEmbed.addPrefetch('preconnect', 'https://googleads.g.doubleclick.net');
      LiteYTEmbed.addPrefetch('preconnect', 'https://static.doubleclick.net');
      LiteYTEmbed.preconnected = true;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement)); // Register custom element
customElements.define('lite-youtube', LiteYTEmbed);
jQuery(document).ready(function () {
  //Speicfically added for the Home page.
  fixHeightCards();
  fixHeightArticle();
  fixHeightCareers();

  //trumcate the manual excerpt length
  jQuery(".ast-excerpt-container p").each(function () {
    var manual_excerpt = jQuery(this).text();
    var manual_excerpt_len = manual_excerpt.length;
    if (manual_excerpt_len > 150) {
      jQuery(this).text(jQuery(this).text().substr(0, 150) + ' ');
    }
  });

  //if the div for Morpheus exists on the page then add the external script
  if (jQuery('.archer-results').length) {
    //console.log('it exists');
    var morpheusScript = '<!-- Begin Morpheus Script --><script src="https://publisher-listings.campusexplorer.com/static/listings.min.js" async></script><!-- End Morpheus Script -->';
    jQuery('head').append(morpheusScript);
  }
});

/* 
* Making sure that on window resize the math recalcualtes so looks right on mobile. 
*/
jQuery(window).on('resize', function () {
  fixHeightCards();
  fixHeightArticle();
  fixHeightCareers();
});

/* 
* Adjust height of cards so the buttons line up - can't do this inside of the wp-admin   
* a class of Cards needs to be added to the outer container
*/
function fixHeightCards() {
  var maxHeight = -1;
  jQuery('.cards .wp-block-uagb-container p').each(function () {
    jQuery(this).css('height', 'auto');
    maxHeight = maxHeight > jQuery(this).height() ? maxHeight : jQuery(this).height();
  });
  jQuery('.cards .wp-block-uagb-container p').each(function () {
    jQuery(this).height(maxHeight);
  });
}

/* 
* Adjust height of Article cards so the buttons line up - can't do this inside of the wp-admin   
* no class is required on article cards on the home page because the post grid has special classes
*/
function fixHeightArticle() {
  var maxHeight = -1;
  jQuery('.wp-block-uagb-post-grid .uagb-post__excerpt p').each(function () {
    jQuery(this).css('height', 'auto');
    maxHeight = maxHeight > jQuery(this).height() ? maxHeight : jQuery(this).height();
  });
  jQuery('.wp-block-uagb-post-grid .uagb-post__excerpt p').each(function () {
    jQuery(this).height(maxHeight);
  });
}

/* 
* Adjust height of careers cards so the buttons line up - can't do this inside of the wp-admin   
* a class of Careers needs to be added to the outer container
*/
function fixHeightCareers() {
  var maxHeight = -1;
  jQuery('.careers .wp-block-uagb-container').find("p:first").each(function () {
    jQuery(this).css('height', 'auto');
    maxHeight = maxHeight > jQuery(this).height() ? maxHeight : jQuery(this).height();
  });
  jQuery('.careers .wp-block-uagb-container').find("p:first").each(function () {
    jQuery(this).height(maxHeight);
  });
}